<div class="w-full border border-collapse border-gray-800 flex rounded-md items-stretch">
  <!--  -->
  <div class="w-fit iBTTiny:min-h-[40px] md:min-h-[54px] border-r border-collapse border-gray-800 flex items-stretch" [ngClass]="labelClass()">
    <div id="LABEL-{{ fieldName() }}" class="w-fit flex items-center justify-end rounded-l-md">
      <div class="px-2 w-full iBTTiny:min-w-[110px] md:min-w-[118px] lg:min-w-[210px] align-middle text-right">{{ fieldLabel() }}:</div>
    </div>
  </div>
  <!--  -->
  <div id="VALUE-{{ fieldName() }}" class="px-2 w-full flex items-center rounded-r-md" [ngClass]="valueClass()">
    <ng-content></ng-content>
  </div>
</div>
